import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { signOut } from 'aws-amplify/auth';
import { AlertService } from '../services/alert.service';
import { ProblemDetails } from '../models/problem-details';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private alertService: AlertService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const sanitizedUrl = err.url?.split('?')[0] ?? 'unknown';
        const problem: ProblemDetails | undefined = err.error?.title ? err.error : undefined;
        const message = problem
          ? this.buildProblemMessage(problem)
          : `HTTP error ${err.status}`;

        console.error(message, err.status, sanitizedUrl);

        if (err.status === 401) {
          signOut({ global: true })
            .then(() => console.log('signed out after 401'))
            .catch((signOutErr) => console.error('sign out failed', signOutErr));
        } else if (err.status === 0) {
          this.alertService.errorToast('Unknown Internal Server Error');
        } else if (problem) {
          this.alertService.errorToast(message);
        } else {
          this.alertService.errorToast('Unknown Server Error');
        }

        return throwError(() => err);
      }),
    );
  }

  private buildProblemMessage(problem: ProblemDetails): string {
    if (problem.errors) {
      const firstError = Object.values(problem.errors).flat()[0];
      return firstError ?? problem.title;
    }
    return `${problem.title}${problem.detail ? ': ' + problem.detail : ''}`;
  }
}
